<template>
    <PatientProfile
        :patientId    = "patientInfo.id"
        :name         = "patientInfo.name"
        :birth        = "patientInfo.birth"
        :age          = "patientInfo.age"
        :weight       = "patientInfo.weight"
        :lastExam     = "resultInfo.examDate"
        :painArea     = "resultInfo.painArea"
        :showPainArea = "false"
    />
    <!-- <div class="btn-group" style="margin:0 20px;">
        <button class="blue-btn" :disabled="!isSaveEnabled" @click="Save">저장</button>
    </div> -->
    <hr style="border:0; border-top:1.5px solid #c8c8c8; margin:12px 0;" />
    <div class="diagnosis-result-container">
        <div class="diagnostics-container">
            <div class="triple-row" v-show="step == 1">
                <!-- [1] 인체 -->
                <div class="double-col left">
                    <div class="cpt-header">
                        <div class="cpt-title">통증 부위 & VAS</div>
                        <button 
                            class="pain-area-reset" 
                            @click="resetPainArea"
                            >
                            통증 부위 초기화
                        </button>
                    </div>
                    <div class="body-desc">※ 통증이 있는 부위를 선택해주세요.</div>
                    <div class="diagnosis-wrapper">
                        <div class="body-shape-section">
                            <div class="svg-container">
                                <!-- 앞모습 -->
                                <div class="svg-imgContainer">
                                    <img src="@/assets/resource/svg/body_shape.svg" class="body-base-img" alt="인체 그림"/>
                                    <div v-for="(p, idx) in frontAreas" :key="`front-${idx}-${forceUpdate}`" class="pain-marker" :class="{ active: selectedFront.includes(idx) }" :style="{ top: p.top, left: p.left }" @click="toggleFront(idx)"></div>
                                </div>
                                <div class="label-row">
                                    <div class="body-label">앞모습</div>
                                    <div class="body-label">뒷모습</div>
                                </div>
                            </div>
                        </div>
                        <div class="vas-section">
                            <div class="vas-icons">
                                <div class="vas-grid">
                                    <span v-for="obj in vasFaces" :key="obj.score" :class="['vas-emoji', { active: obj.score === vasValue }]" :style="{ color: obj.score === vasValue ? obj.color : '#bbb', cursor: 'pointer' }" @click="vasValue = obj.score">
                                        <img
                                            :src="require(`@/assets/resource/icon/${obj.fileName}.png`)"
                                            alt="vas score"
                                        />
                                        <div class="vas-score">{{ obj.score }}</div>
                                    </span>
                                    <div class="vas-text">통증 정도(VAS)</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="selected-areas">
<!--                        <strong>선택된 부위: </strong>-->
<!--                        <span v-if="selectedFront.length === 0">없음</span>-->
<!--                        <span v-else>{{ selectedFront.map(i => bodyName[i]).join(', ') }}</span>-->
                        <strong>그룹 선택된 부위: </strong>
                        <span v-if="selectedFront.length === 0"></span>
                        <span v-else>{{ getDisplayLabels(selectedFront, bodyName) }}</span>
                    </div>
                </div>
                <!-- [2] current & time 설정 -->
                <div class="double-col right">
                    <div class="cpt-header">
                        <div class="cpt-title">CURRENT & TIME 설정</div>
                    </div>
                    <!-- Current Limit -->
                    <div class="option-row">
                        <div class="option-label">Current Limit</div>
                        <div class="radio-group">
                            <label v-for="v in [300,200,150,100]" :key="v" class="radio-label">
                                <input type="radio" name="current" :value="v" v-model="currentLimit"/>
                                <span class="radio-text">{{ v }} μA</span>
                            </label>
                            <label class="radio-label">
                                <input type="radio" name="current" value="custom" v-model="currentLimit"/>
                                <span class="radio-text">
                                    <button
                                        v-if="currentLimit !== 'custom'"
                                        type="button"
                                        class="input-like"
                                        @click.stop="currentLimit = 'custom'"
                                    >
                                    input μA
                                    </button>
                                    <input
                                        v-else
                                        ref="currentInputRef"
                                        type="number"
                                        class="custom-input"
                                        v-model="customCurrent"
                                        placeholder="input μA"
                                        style="width:120px;"
                                        @click.stop
                                        @blur="(e) => onBlurNumberInput(e, 'customCurrent')"
                                        @keyup.enter="handleCurrentInputEnter"
                                        enterkeyhint="next"
                                    />
                                </span>
                            </label>
                        </div>
                    </div>
                    <!-- voltage limit -->
                    <div class="option-row">
                        <div class="option-label">Voltage Limit</div>
                        <div class="radio-group">
                            <label v-for="v in [200,150,100]" :key="v" class="radio-label">
                                <input type="radio" name="voltageLimit" :value="v" v-model="voltageLimit" />
                                <span class="radio-text">{{ v }} volt</span>
                            </label>
                            <label class="radio-label">
                                <input type="radio" name="voltageLimit" value="custom" v-model="voltageLimit" />
                                <span class="radio-text">
                                    <button
                                        v-if="voltageLimit  !== 'custom'"
                                        type="button"
                                        class="input-like"
                                        @click.stop="voltageLimit = 'custom'"
                                    >
                                    input volt
                                    </button>
                                    <input
                                        v-else
                                        ref="voltageInputRef"
                                        type="number"
                                        class="custom-input"
                                        v-model="customVoltage"
                                        placeholder="input volt"
                                        style="width:120px;"
                                        @click.stop
                                        @blur="(e) => onBlurNumberInput(e, 'customVoltage')"
                                        @keyup.enter="handleVoltageInputEnter"
                                        enterkeyhint="next"
                                    />
                                </span>
                            </label>
                        </div>
                    </div>
                    <!-- C.P.T Time -->
                    <div class="option-row">
                        <div class="option-label">C.P.T & P.E.C Time</div>
                        <div class="radio-group">
                            <label v-for="v in [30,40,60]" :key="v" class="radio-label">
                                <input type="radio" name="setTime" :value="v" v-model="setTime"/>
                                <span class="radio-text">{{ v }} sec</span>
                            </label>
                            <label class="radio-label">
                                <input type="radio" name="setTime" value="custom" v-model="setTime"/>
                                <span class="radio-text">
                                    <button
                                        v-if="setTime !== 'custom'"
                                        type="button"
                                        class="input-like"
                                        @click.stop="setTime = 'custom'"
                                    >
                                    input sec
                                    </button>
                                    <input
                                        v-else
                                        ref="timeInputRef"
                                        type="number"
                                        class="custom-input"
                                        v-model="customSetTime"
                                        placeholder="input sec"
                                        style="width:120px;"
                                        @click.stop
                                        @blur="(e) => onBlurNumberInput(e, 'customSetTime')"
                                        @keyup.enter="handleTimeInputEnter"
                                        enterkeyhint="done"
                                    />
                                </span>
                            </label>
                        </div>
                    </div>
                   <!-- <div class="vas-section">
                       <button class="blue-btn" @click="recordMeasurementEvent('errorTest')">감사 실패 테스트 버튼</button>
                   </div> -->
                </div>
            </div>
            <div class="btn-group mt10 mb30" v-show="step == 1">
                <button class="pain-cancel-btn mr_auto" @click="router.push('/patientlist/patientlist')">진단 검사 취소</button>
                <button class="next-btn" @click="nextStep(2)">다음</button>
            </div>
            <div class="triple-row" v-show="step == 2">
                <!-- [3] current & time 설정 -->
                <div class="double-col left">
                    <!-- C.P.T 검사 영역 -->
                     <div class="cpt-header">
                        <div class="cpt-title">C.P.T 검사</div>
                        <button 
                            class="cpt-reset" 
                            @click="resetCpt"
                            :disabled="runningType !== null"
                            >
                            C.P.T 초기화
                        </button>
                     </div>
                    <div class="cpt-section">
                        <div
                            v-for="(m, idx) in cptMeasurements"
                            :key="m.id"
                            class="cpt-row"
                        >
                            <div class="cpt-input-wrapper">
                                <input
                                    class="cpt-input"
                                    type="number"
                                    :value="m.value"
                                    readonly
                                />
                                <!-- 해당 회차 초기화 버튼 -->
                                <button
                                    class="cpt-clear-btn"
                                    @click="clearCptIndex(idx)"
                                    type="button"
                                    :disabled="runningType !== null"
                                >
                                    ✕
                                </button>
                            </div>
                            <button
                                class="cpt-start"
                                @click="startMeasurement('cpt', idx)"
                                :disabled="runningType !== null"
                            >
                            ▶ START
                            </button>
                            <button
                                :class="{'cpt-stop': true, active: cptActive[idx]}"
                                @click="stopMeasurement('cpt', idx)"
                                :disabled="!(runningType === 'cpt' && runningIndex === idx)"
                            >
                            ■ STOP
                            </button>
                        </div>
                        <!-- Mean -->
                       <div class="cpt-mean-wrapper">
                            <span class="mean-label">Mean</span>
                            <input
                                class="cpt-mean-input"
                                :value="cptMean"
                                readonly
                            />
                        </div>
                    </div>
                    <!-- P.E.C 검사 영역 -->
                     <div class="pec-header">
                        <div class="pec-title">P.E.C 검사</div>
                        <button 
                            class="pec-reset" 
                            @click="resetPec"
                            :disabled="runningType !== null"
                            >
                            P.E.C 초기화
                        </button>
                     </div>
                    <div class="pec-section">
                        <div
                            v-for="(m, idx) in pecMeasurements"
                            :key="m.id"
                            class="pec-row"
                        >
                            <div class="pec-input-wrapper">
                                <input
                                    class="pec-input"
                                    type="number"
                                    :value="m.value"
                                    readonly
                                />
                                <!-- 해당 회차 초기화 버튼 -->
                                <button
                                    class="pec-clear-btn"
                                    @click="clearPecIndex(idx)"
                                    type="button"
                                    :disabled="runningType !== null"
                                >
                                    ✕
                                </button>
                            </div>
                            <button
                                class="pec-start"
                                @click="startMeasurement('pec', idx)"
                                :disabled="runningType !== null"
                            >
                            ▶ START
                            </button>
                            <button
                                :class="{'pec-stop': true, active: pecActive[idx]}"
                                @click="stopMeasurement('pec', idx)"
                                :disabled="!(runningType === 'pec' && runningIndex === idx)"
                            >
                            ■ STOP
                            </button>
                        </div>
                        <!-- Mean -->
                       <div class="pec-mean-wrapper">
                            <span class="mean-label">Mean</span>
                            <input
                                class="pec-mean-input"
                                :value="pecMean"
                                readonly
                            />
                        </div>
                    </div>
                </div>
                <!-- [4] start, stop -->
                <div class="double-col right">
                    <div class="cpt-title">CURRENT(μA)</div>
                    <div class="chart-section" style="height:320px; width:100%;">
                        <canvas ref="chartCanvas"></canvas>
                    </div>
                    <!-- <div class="cpt-title">결과</div> -->
                    <div class="triple-row-score">
                        <div class="score-box total">
                            <span class="score-label">SCORE</span>
                            <span class="score-value highlight">{{ resultInfo.score }}</span>
                            <span class="score-unit"></span>
                        </div>
                        <div class="score-box total">
                            <span class="score-label">VAS</span>
                            <span class="score-value highlight">{{ vasValue }}</span>
                            <span class="score-unit"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group diagnostics-btn-group" v-show="step == 2" >
                <button
                    class="prev-btn mr_auto"
                    @click="handlePrevClick"
                    :disabled="runningType !== null"
                    :class="{ disabled: runningType !== null }"
                >
                이전
                </button>
                <button 
                    class="diagnostic-save-btn" 
                    :disabled="!isSaveEnabled || runningType !== null" 
                    @click="Save"
                >
                저장
                </button>
            </div>
            <div class="triple-row" v-show="step == 3">
                <!-- [5] 차트 -->
                <div class="double-col left">
                </div>
                <!-- [6] 결과 -->
                <div class="double-col right">
                </div>
            </div>
            <div class="btn-group mt30" v-show="step == 3">
                <button class="prev-btn mr_auto" @click="step = 2">이전</button>
            </div>
        </div>
    </div>
    <div class="popup-backdrop" v-if="cptPopupStatus" id="cptPopup">
        <div class="popup-modal">
            <div class="popup-header">
                <span class="popup-title">C.P.T</span>
                <!-- ✅ 초기화 버튼 -->
                <button class="cpt-reset" type="button" @click="resetCpt">
                    초기화
                </button>
            </div>
            <!-- ✅ 3회차를 한 번에 표시 -->
            <div class="popup-text" style="margin-bottom: 10px;">
                <span class="diag-title">총 3회 검사입니다. 각 회차별 START/STOP으로 진행하세요.</span>
            </div>
            <div class="cpt-body">
                <div
                    v-for="(m, idx) in cptMeasurements"
                    :key="m.id"
                    class="cpt-row"
                >
                    <!-- 값 표시 (readonly) -->
                    <input
                    class="cpt-input"
                    type="number"
                    :value="m.value"
                    readonly
                    />

                    <button
                    class="cpt-start"
                    type="button"
                    @click="startMeasurement('cpt', idx)"
                    :disabled="cptActive[idx]"
                    >
                    ▶ START
                    </button>

                    <button
                    :class="{'cpt-stop': true, active: cptActive[idx]}"
                    type="button"
                    @click="stopMeasurement('cpt', idx)"
                    :disabled="!cptActive[idx]"
                    >
                    STOP
                    </button>
                    <!-- 완료 체크 (값이 들어오면 체크되게) -->
                    <input
                    class="cpt-checkbox"
                    type="checkbox"
                    :checked="Number(m.value) > 0"
                    disabled
                    />
                </div>
                <!-- Mean -->
                <div class="cpt-mean">
                    <span>Mean</span>
                    <input class="cpt-mean-input" :value="cptMean" readonly />
                </div>
            </div>
            <div class="popup-btn-group">
            <button type="button" class="gray-btn" @click="closeCptPopup">닫기</button>
            </div>
        </div>
    </div>
    <div class="popup-backdrop" v-if="pecPopupStatus" id="pecPopup">
        <div class="popup-modal">
            <div class="popup-header">
                <span class="popup-title">P.E.C 검사 {{ pecPopupStep == 1 ? '안내' : pecPopupStep == 5 ? '완료' : '' }}</span>
            </div>
            <template v-if="pecPopupStep == 1">
                <div class="popup-text">
                    <span class="diag-title">P.E.C 검사는 총 3번의 걸쳐 진행됩니다.</span>
                    <span class="diag-title">start 버튼을 눌러 검사를 시작하며, stop 버튼을 눌러 해당 회차의 검사를 완료합니다.</span>
                    <br>
                    <span class="diag-title">확인 버튼을 눌러 검사를 시작하고, 취소 버튼을 누르면 이전 화면으로 돌아갑니다.</span>
                </div>
                <div class="popup-btn-group">
                    <button class="gray-btn" @click="closePecPopup">검사 취소</button>
                    <button class="blue-btn" @click="pecPopupStep = 2">검사 시작</button>
                </div>
            </template>

            <template v-if="(pecPopupStep > 1 && pecPopupStep < 5) && pecPopupComplete < 2">
                <div class="popup-text">
                    <span class="diag-title">start 버튼을 눌러 P.E.C 검사를 시작합니다.</span>
                    <span class="diag-title">stop 버튼을 눌러 검사를 완료합니다.</span>
                </div>
                <div class="diag-btn-container" style="margin-top:auto;">
                    <span class="diag-title">P.E.C {{pecPopupStep == 2 ? '첫' : pecPopupStep == 3 ? '두' : '세'}}번째 검사</span>
                    <div class="diag-btn-group">
                        <button class="cpt-start" @click="startMeasurement('pec', pecPopupStep - 2)" :disabled="pecActive[pecPopupStep - 2]">
                            <span style="margin-right:5px;">&#9654;</span>START
                        </button>
                        <button :class="{'cpt-stop': true, active: pecActive[pecPopupStep - 2]}" @click="stopMeasurement('pec', pecPopupStep - 2)" :disabled="!pecActive[pecPopupStep - 2]">
                            <svg width="16" height="16" viewBox="0 0 16 16" style="vertical-align: middle; margin-right: 7px; fill: #fff;">
                                <rect x="3" y="3" width="10" height="10"/>
                            </svg>STOP
                        </button>
                    </div>
                </div>
                <div class="popup-btn-group">
                    <button type="button" class="blue-btn" :disabled="pecActive[pecPopupStep - 2]" @click="closePecPopup">검사 종료</button>
                </div>
            </template>
            <template v-if="pecPopupComplete == 2">
                <div class="popup-text">
                    <span class="diag-title">P.E.C 검사가 모두 완료되었습니다.</span>
                </div>
                <div class="popup-btn-group">
                    <button type="button" class="gray-btn" @click="closePecPopup">확인</button>
                </div>
            </template>
        </div>
    </div>
</template>
<script setup>
    defineOptions({
        meta: {
            title: '통증 측정 실행',
            segmentKey: 'patientId'
        }
    })

    import PatientProfile from "@/components/common/PatientProfile.vue"
    import { ref, onMounted, computed, watch, onBeforeUnmount, inject, nextTick   } from 'vue'
    import { Chart, ScatterController, PointElement, LinearScale, Tooltip, Legend } from 'chart.js'
    import {useRoute,useRouter} from "vue-router";
    import api, {urls}          from "@/api";
    import { convertUtils }     from '@/utils/convertUtils'
    import { commonUtils }      from "@/utils/commonUtils";
    Chart.register(ScatterController, PointElement, LinearScale, Tooltip, Legend)
    import { useAuthStore } from '@/stores/auth';
    import { useAppAlert }  from '@/composables/useAppAlert'


    const { showAlert, confirm } = useAppAlert()

    const count = ref(0)
    const step  = ref(1)

    // BLE 상태와 액션 주입
    const bleState          = inject('bleState')
    const bleActions        = inject('bleActions')

    const route             = useRoute()
    const router            = useRouter()
    const currentLimit      = ref(200)
    const currentLimitMax   = 400
    const cptTime           = 0
    const pecTime           = 0
    const setTime           = ref(30)
    const voltageLimit      = ref(200);
    const voltageLimitMax   = 200;

    const customCurrent     = ref('')
    const customSetTime     = ref('')
    const customVoltage     = ref('')
    const vasValue          = ref('')
    const patientInfo       = ref({})

    const selectedCategory  = ref('')
    const comment           = ref('')
    const selectedDisease   = ref('')

    const cptReceiveIndex   = ref(null);
    const pecReceiveIndex   = ref(null);

    const cptLastValue      = ref(0)
    const pecLastValue      = ref(0)
    // ✅ 수정: 타이머를 역할별로 분리
    // - streamTimer: 실시간 수신(0x01) 끊김 감지용 500ms 타이머(기존 cptMeasurementTimer 용도)
    // - hardTimer  : 최대 검사시간(limitMs) 타임아웃(이번에 새로 추가)
    const cptStreamTimer = ref(null)     
    const pecStreamTimer = ref(null)    
    const cptHardTimer   = ref(null)       
    const pecHardTimer   = ref(null)      

    const status         = ref('')
    const activeType     = ref('')
    const timeMs         = ref(0)
    const checkError     = ref(false)
    const ctrlCount      = ref(0)
    const startCount     = ref(0)
    const stopCount      = ref(0)

    // popup
    const cptPopupStatus    = ref(false)
    const pecPopupStatus    = ref(false)
    const cptPopupStep      = ref(1)
    const pecPopupStep      = ref(1)
    const cptPopupComplete  = ref(-1)
    const pecPopupComplete  = ref(-1)
    const globalMsg         = ref('')

    const runningType       = ref(null)  // 'cpt' | 'pec' | null
    const runningIndex      = ref(null)  // number | null

    const currentInputRef = ref(null)
    const voltageInputRef = ref(null)
    const timeInputRef    = ref(null)

    // 회차별 측정 시작 시각(ms)
    const cptStartAt = ref([null, null, null]); // index 0~2
    const pecStartAt = ref([null, null, null]);

    // 회차별 실제 소요시간(ms)
    const cptDurations = ref([0, 0, 0]);
    const pecDurations = ref([0, 0, 0]);

    const cptMeasurements = ref([
        { id: 1, name: 'cptValue1', value: 0, active: false },
        { id: 2, name: 'cptValue2', value: 0, active: false },
        { id: 3, name: 'cptValue3', value: 0, active: false }
    ]);

    const pecMeasurements = ref([
        { id: 1, name: 'pecValue1', value: 0, active: false },
        { id: 2, name: 'pecValue2', value: 0, active: false },
        { id: 3, name: 'pecValue3', value: 0, active: false }
    ])

    const cptMean = computed(() => {
        const sum = cptMeasurements.value.reduce((acc, cur) => acc + Number(cur.value || 0), 0)
        return (sum / cptMeasurements.value.length).toFixed(1)
    })

    const pecMean = computed(() => {
        const sum = pecMeasurements.value.reduce((acc, cur) => acc + Number(cur.value || 0), 0)
        return (sum / pecMeasurements.value.length).toFixed(1)
    })

    const resetCpt = async () => {
        const result = await confirm("C.P.T 검사를 초기화하시겠습니까?")
        if (!result) return

        cptMeasurements.value.forEach(item => item.value = 0)
        cptActive.value = [false, false, false]
        cptReceiveIndex.value = null

        cptStartAt.value = [null, null, null];
        cptLastValue.value = 0
        cptDurations.value = [0, 0, 0];

        clearHardTimer('cpt')      // 타이머 정리
        clearStreamTimer('cpt')    // 
    }

    const resetPec = async () => {
        const result = await confirm("P.E.C 검사를 초기화하시겠습니까?")
        if (!result) return

        pecMeasurements.value.forEach(item => item.value = 0)
        pecActive.value       = [false, false, false]
        pecReceiveIndex.value = null

        pecStartAt.value   = [null, null, null];
        pecLastValue.value = 0
        pecDurations.value = [0, 0, 0];

        clearHardTimer('pec')     
        clearStreamTimer('pec')    
    }

    const resetPainArea = async () => {
        const result = await confirm("선택한 통증 부위를 초기화하시겠습니까?")
        if (!result) return

        selectedFront.value = []
        forceUpdate.value++
    }

    // 모든 검사 데이터 및 상태를 초기화하는 함수
    const resetAllMeasurements = () => {
        // 1. 실행 상태를 즉시 해제하여 handleDataReceived의 로직 실행 방지
        runningType.value = null;
        runningIndex.value = null;
        status.value = 'stop';
        activeType.value = '';

        // 2. 모든 타이머 즉시 중지
        clearHardTimer('cpt');
        clearHardTimer('pec');
        clearStreamTimer('cpt');
        clearStreamTimer('pec');

        // 3. 데이터 초기화
        cptMeasurements.value.forEach(v => v.value = 0);
        cptActive.value = [false, false, false];
        cptDurations.value = [0, 0, 0];
        cptStartAt.value = [null, null, null];
        cptLastValue.value = 0;
        cptReceiveIndex.value = null;

        pecMeasurements.value.forEach(v => v.value = 0);
        pecActive.value = [false, false, false];
        pecDurations.value = [0, 0, 0];
        pecStartAt.value = [null, null, null];
        pecLastValue.value = 0;
        pecReceiveIndex.value = null;

        resultInfo.value.score = 0;
        console.log("모든 검사 데이터가 초기화되었습니다.");
    };

    const resultInfo = ref({
        examDate: '',
        painArea: '',
        vas: 0,
        cpt: 0,
        pec: 0,
        score: 0
    })

    const vasFaces = [
        { score: 10,  fileName: "vas_score_10"  },
        { score: 20,  fileName: "vas_score_20"  },
        { score: 30,  fileName: "vas_score_30"  },
        { score: 40,  fileName: "vas_score_40"  },
        { score: 50,  fileName: "vas_score_50"  },
        { score: 60,  fileName: "vas_score_60"  },
        { score: 70,  fileName: "vas_score_70"  },
        { score: 80,  fileName: "vas_score_80"  },
        { score: 90,  fileName: "vas_score_90"  },
        { score: 100, fileName: "vas_score_100" }
    ]

    // [앞모습] 선택점 좌표 및 반경(실루엣 위치에 맞게 추가/수정 가능)
    const bodyCode = [
        //앞쪽
        { cx: 69.5, cy: 43     },   // 목        [0]
        { cx: 44,   cy: 67     },   // 우측 어깨  [1]
        { cx: 33.5, cy: 103    },   // 우측 상완  [2]
        { cx: 30.5, cy: 139    },   // 우측 전완  [3]
        { cx: 17,   cy: 174    },   // 우측 손    [4]
        { cx: 47,   cy: 163    },   // 우측 골반  [5]
        { cx: 54,   cy: 210    },   // 우측 허벅지  [6]
        { cx: 54,   cy: 280    },   // 우측 정강이  [7]
        { cx: 59.5, cy: 329    },   // 우측 발  [8]

        { cx: 94,    cy: 67    },   // 좌측 어깨  [9]
        { cx: 106,   cy: 103   },   // 좌측 상완  [10]
        { cx: 109.5, cy: 139   },   // 좌측 전완  [11]
        { cx: 122,   cy: 174   },   // 좌측 손    [12]
        { cx: 92,    cy: 163   },   // 좌측 골반  [13]
        { cx: 86,    cy: 210   },   // 좌측 허벅지  [14]
        { cx: 85,    cy: 280   },   // 좌측 정강이  [15]
        { cx: 80.5,  cy: 329   },   // 좌측 발  [16]

        { cx: 69.5, cy: 99.5   },   // 가슴  [17]
        { cx: 69.7, cy: 128.5  },   // 배  [18]

        //뒤쪽
        { cx: 231.4, cy: 43    },   // 목  [19]
        { cx: 206,   cy: 67    },   // 좌측 어깨  [20]
        { cx: 195.5, cy: 103   },   // 좌측 상완  [21]
        { cx: 192,   cy: 139   },   // 좌측 전완  [22]
        { cx: 179,   cy: 174   },   // 좌측 손  [23]
        { cx: 209,   cy: 163   },   // 좌측 엉덩이  [24]
        { cx: 215,   cy: 210   },   // 좌측 허벅지  [25]
        { cx: 217,   cy: 280   },   // 좌측 종아리  [26]
        { cx: 221,   cy: 329   },   // 좌측 발  [27]

        { cx: 255, cy: 67      },   // 우측 어깨  [28]
        { cx: 268, cy: 103     },   // 우측 상완  [29]
        { cx: 271, cy: 139     },   // 우측 전완  [30]
        { cx: 284, cy: 174     },   // 우측 손  [31]
        { cx: 254, cy: 163     },   // 우측 엉덩이  [32]
        { cx: 248, cy: 210     },   // 우측 허벅지  [33]
        { cx: 246, cy: 280     },   // 우측 종아리  [34]
        { cx: 241, cy: 329     },   // 우측 발  [35]

        { cx: 231.5, cy: 99.5  },   // 등  [36]
        { cx: 231.5, cy: 128.5 },   // 허리  [37]
    ];

    const PAIR_GROUPS = [
        // {좌측, 우측}
        //목
        { groupName: '목 전후면', parts: [0, 19] },
        //어깨
        { groupName: '양측 어깨 전면', parts: [9, 1] },
        { groupName: '양측 어깨 후면', parts: [20, 28] },
        { groupName: '좌측 어깨 전후면', parts: [9, 20] },
        { groupName: '우측 어깨 전후면', parts: [1, 28] },
        { groupName: '양측 어깨 전후면', parts: [9, 1, 20, 28] },
        //상완
        { groupName: '양측 상완 전면', parts: [10, 2] },
        { groupName: '양측 상완 후면', parts: [21, 29] },
        { groupName: '좌측 상완 전후면', parts: [10, 21] },
        { groupName: '우측 상완 전후면', parts: [2, 29] },
        { groupName: '양측 상완 전후면', parts: [10, 2, 21, 29] },
        //전완
        { groupName: '양측 전완 전면', parts: [11, 3] },
        { groupName: '양측 전완 후면', parts: [22, 30] },
        { groupName: '좌측 전완 전후면', parts: [11, 22] },
        { groupName: '우측 전완 전후면', parts: [3, 30] },
        { groupName: '양측 전완 전후면', parts: [11, 3, 22, 30] },
        //손바닥
        { groupName: '양측 손바닥', parts: [12, 4] },
        //손등
        { groupName: '양측 손등', parts: [23, 31] },
        //손
        { groupName: '좌측 손', parts: [12, 23] },
        { groupName: '우측 손', parts: [4, 31] },
        { groupName: '양측 손', parts: [12, 4, 23, 31] },
        //골반
        { groupName: '양측 골반', parts: [13, 5] },
        //엉덩이
        { groupName: '양측 엉덩이', parts: [24, 32] },
        //허벅지
        { groupName: '양측 허벅지 전면', parts: [14, 6] },
        { groupName: '양측 허벅지 후면', parts: [25, 33] },
        { groupName: '좌측 허벅지 전후면', parts: [14, 25] },
        { groupName: '우측 허벅지 전후면', parts: [6, 33] },
        { groupName: '양측 허벅지 전후면', parts: [14, 6, 25, 33] },
        //정강이
        { groupName: '양측 정강이', parts: [15, 7] },
        //종아리
        { groupName: '양측 종아리', parts: [26, 34] },
        //발
        { groupName: '양측 발 전면', parts: [16, 8] },
        { groupName: '양측 발 후면', parts: [27, 35] },
        { groupName: '좌측 발 전후면', parts: [16, 27] },
        { groupName: '우측 발 전후면', parts: [8, 35] },
        { groupName: '양측 발 전후면', parts: [16, 8, 27, 35] },

        //상체
        {
            groupName: '상체 전면',   //목, 어깨, 상완, 전완, 손바닥, 가슴, 배
            parts:
                [
                    0, 19,          //목
                    9, 1,       //어깨(좌,우)
                    10, 2,      //상완(좌,우)
                    11, 3,      //전완(좌,우)
                    12, 4,      //손바닥(좌,우)
                    17,         //가슴
                    18          //배
                ]
        },
        {
            groupName: '상체 후면',   //목, 어깨, 상완, 전완, 손등, 등, 허리
            parts:
                [
                    19,          //목
                    20, 28,     //어깨(좌,우)
                    21, 29,     //상완(좌,우)
                    22, 30,     //전완(좌,우)
                    23,31,      //손등(좌,우)
                    36,         //등
                    37          //허리
                ]
        },
        {
            groupName: '상체 전반',   //목, 어깨, 상완, 전완, 손, 가슴, 배
            parts:
                [
                    //전면
                    0,          //목
                    9, 1,       //어깨(좌,우)
                    10, 2,      //상완(좌,우)
                    11, 3,      //전완(좌,우)
                    12, 4,      //손바닥(좌,우)
                    17,         //가슴
                    18,         //배
                    //후면
                    19,          //목
                    20, 28,     //어깨(좌,우)
                    21, 29,     //상완(좌,우)
                    22, 30,     //전완(좌,우)
                    23,31,      //손등(좌,우)
                    36,         //등
                    37          //허리
                ]
        },
        //하체
        {
            groupName: '하체 전면',   //골반, 허벅지, 정강이, 발
            parts:
                [
                    13, 5,      //골반(좌,우)
                    14, 6,      //허벅지(좌,우)
                    15, 7,      //정강이(좌,우)
                    16, 8,      //발(좌,우)
                ]
        },
        {
            groupName: '하체 후면',   //엉덩이, 허벅지, 종아리, 발
            parts:
                [
                    24, 32,      //엉덩이(좌,우)
                    25, 33,      //허벅지(좌,우)
                    26, 34,      //종아리(좌,우)
                    27, 35,      //발(좌,우)
                ]
        },
        {
            groupName: '하체 전반',   //골반, 엉덩이, 허벅지, 정강이, 종아리, 발
            parts:
                [
                    //전면
                    13, 5,      //골반(좌,우)
                    14, 6,      //허벅지(좌,우)
                    15, 7,      //정강이(좌,우)
                    16, 8,      //발(좌,우)
                    //후면
                    24, 32,      //엉덩이(좌,우)
                    25, 33,      //허벅지(좌,우)
                    26, 34,      //종아리(좌,우)
                    27, 35,      //발(좌,우)
                ]
        },
        {
            groupName: '몸 전체',
            parts:
                [
                    //상체 전면
                    0,          //목
                    9, 1,       //어깨(좌,우)
                    10, 2,      //상완(좌,우)
                    11, 3,      //전완(좌,우)
                    12, 4,      //손바닥(좌,우)
                    17,         //가슴
                    18,         //배
                    //후면
                    19,          //목
                    20, 28,     //어깨(좌,우)
                    21, 29,     //상완(좌,우)
                    22, 30,     //전완(좌,우)
                    23,31,      //손등(좌,우)
                    36,         //등
                    37,          //허리

                    //하체 전면
                    13, 5,      //골반(좌,우)
                    14, 6,      //허벅지(좌,우)
                    15, 7,      //정강이(좌,우)
                    16, 8,      //발(좌,우)
                    //후면
                    24, 32,      //엉덩이(좌,우)
                    25, 33,      //허벅지(좌,우)
                    26, 34,      //종아리(좌,우)
                    27, 35,      //발(좌,우)
                ]
        },
        // { groupName: '양측 손등 (후면)', parts: ['좌측 손등 (후면)', '우측 손등 (후면)'] },
    ];

    const bodyName = [
        // 앞쪽
        '목 (전면)',
        '우측 어깨 (전면)',
        '우측 상완 (전면) ',
        '우측 전완 (전면)',
        '우측 손바닥 (전면)',
        '좌측 골반 (전면)',
        '우측 허벅지 (전면)',
        '우측 정강이 (전면)',
        '우측 발 (전면)',

        '좌측 어깨 (전면)',
        '좌측 상완 (전면)',
        '좌측 전완 (전면)',
        '좌측 손바닥 (전면)',
        '좌측 골반 (전면)',
        '좌측 허벅지 (전면)',
        '좌측 정강이 (전면)',
        '좌측 발 (전면)',

        '가슴 (전면)',
        '배 (전면)',

        // 뒤쪽
        '목 (후면)',
        '좌측 어깨 (후면)',
        '좌측 상완 (후면)',
        '좌측 전완 (후면)',
        '좌측 손등 (후면)',
        '좌측 엉덩이 (후면)',
        '좌측 허벅지 (후면)',
        '좌측 종아리 (후면)',
        '좌측 발 (후면)',

        '우측 어깨 (후면)',
        '우측 상완 (후면)',
        '우측 전완 (후면)',
        '우측 손등 (후면)',
        '우측 엉덩이 (후면)',
        '우측 허벅지 (후면)',
        '우측 종아리 (후면)',
        '우측 발 (후면)',

        '등 (후면)',
        '허리 (후면)'
    ];

    const diseaseCategories = [
        { name: '급성요통' },
        { name: '섬유근육통' },
        { name: '중추성통증'},
        { name: '말초신경병증'}
    ]

    // 선택 상태 관리(복수 선택 가능)
    const selectedFront = ref([])

    const frontAreas = bodyCode.map(p => ({
        ...p,
        top: (p.cy / 338 * 100).toFixed(2) + '%',
        left: (p.cx / 301 * 100).toFixed(2) + '%'
    }));

    const cptActive = ref([false, false, false]);
    const pecActive = ref([false, false, false]);

    const cptSeries = ref([])
    const pecSeries = ref([])

    const chartCanvas = ref()
    let chartInstance = null

    const forceUpdate = ref(0);

    const clearCptIndex = async (idx) => {
        if (runningType.value === 'cpt' && runningIndex.value === idx) {
            showAlert('검사가 진행 중입니다. 검사 중지 후 삭제해주세요.')
            return
        }

        const result = await confirm(`${idx +1}회차 C.P.T 검사를 삭제하시겠습니까?`)
        if (!result) return

        cptMeasurements.value[idx].value = 0
        cptActive.value[idx]             = false
        cptStartAt.value[idx]            = null;
        cptDurations.value[idx]          = 0;

    }

    const clearPecIndex = async (idx) => {
        if (runningType.value === 'pec' && runningIndex.value === idx) {
            showAlert('검사가 진행 중입니다. 검사 중지 후 삭제해주세요.')
            return
        }

        const result = await confirm(`${idx +1}회차 P.E.C 검사를 삭제하시겠습니까?`)
        if (!result) return

        pecMeasurements.value[idx].value = 0
        pecActive.value[idx]             = false
        pecStartAt.value[idx]            = null;
        pecDurations.value[idx]          = 0;

    }

    const currentLimitYMax = computed(() => {
        const v =
            currentLimit.value === 'custom'
            ? Number(customCurrent.value)
            : Number(currentLimit.value);

        // 값이 없거나 NaN이면 기본값(예: 256) 사용
        if (!Number.isFinite(v) || v <= 0) return 256;

        return v;
    });

    // 평균 소요시간(sec) (측정된 회차만 평균)
    const cptAvgTimeSec = computed(() => {
        const valid = cptDurations.value.filter(ms => Number(ms) > 0);
        if (!valid.length) return 0;
        return +(valid.reduce((a, b) => a + b, 0) / valid.length / 1000).toFixed(1);
    });

    const pecAvgTimeSec = computed(() => {
        const valid = pecDurations.value.filter(ms => Number(ms) > 0);
        if (!valid.length) return 0;
        return +(valid.reduce((a, b) => a + b, 0) / valid.length / 1000).toFixed(1);
    });

    // duration 계산 함수(STOP/확정 수신/타임아웃 모두에서 호출)
    function finalizeDuration(type, index, forcedMs = null) { // forcedMs 추가
        const end = Date.now()

        if (type === 'cpt') {
            const start = cptStartAt.value[index]
            if (forcedMs !== null) cptDurations.value[index] = forcedMs
            else if (start) cptDurations.value[index] = end - start
            cptStartAt.value[index] = null
        } else if (type === 'pec') {
            const start = pecStartAt.value[index]
            if (forcedMs !== null) pecDurations.value[index] = forcedMs
            else if (start) pecDurations.value[index] = end - start
            pecStartAt.value[index] = null
        }
    }

    // 현재 limit 값 숫자로 뽑는 유틸
    function getCurrentLimitValueNumber() { 
        const v =
            currentLimit.value === 'custom'
            ? Number(customCurrent.value)
            : Number(currentLimit.value)

        if (!Number.isFinite(v) || v <= 0) return 0
        return v
    }

    // hard timer clear 유틸
    function clearHardTimer(type) { 
        if (type === 'cpt' && cptHardTimer.value) {
            clearTimeout(cptHardTimer.value)
            cptHardTimer.value = null
        }
        if (type === 'pec' && pecHardTimer.value) {
            clearTimeout(pecHardTimer.value)
            pecHardTimer.value = null
        }
    }

    // stream timer clear 유틸
    function clearStreamTimer(type) { 
        if (type === 'cpt' && cptStreamTimer.value) {
            clearTimeout(cptStreamTimer.value)
            cptStreamTimer.value = null
        }
        if (type === 'pec' && pecStreamTimer.value) {
            clearTimeout(pecStreamTimer.value)
            pecStreamTimer.value = null
        }
    }

    function toggleFront(idx) {
        if (selectedFront.value.includes(idx)) {
            selectedFront.value = selectedFront.value.filter(i => i !== idx);
        } else {
            selectedFront.value = [...selectedFront.value, idx];
        }
        forceUpdate.value++;
    }

    function PatientData(id) {
        api.post(urls.patientList.patientData, { id: id })
            .then(res => {
                const data = res.data.list ? res.data.list[0] : res.data; // list 배열로 올 수도 있음
                // 응답 필드 → patientInfo 매핑
                patientInfo.value = {
                    id       : data.patient_id,
                    name     : data.name,
                    birth    : data.dob || '',
                    age      : commonUtils.calcAge(data.dob),
                    weight   : data.weight,
                    lastExam : data.created_at ? data.created_at.split('T')[0] : '',
                    painArea : data.pain_area || ''
                };
            })
            .catch(err =>{
                showAlert("환자 정보 불러오는데 실패했습니다.")
            })
    }

    function calculateScore(cptMean, pecMean) {
        // 평균값이 숫자인지 먼저 체크
        const cpt = parseFloat(cptMean);
        const pec = parseFloat(pecMean);

        if (isNaN(cpt) || isNaN(pec) || cpt === 0) return null;  // 0으로 나누기 방지
        const score = ((pec - cpt) / cpt) * 100;
        return score.toFixed(1); // 소수점 1자리로 표시
    }

    async function startMeasurement(type, index) {
        if(!bleState.deviceConnected.value || !bleState.isReady.value){
            showAlert('장비가 연결되어 있지 않거나 통신 준비가 되지 않았습니다.')
            return
        }

        if (bleState.isCharging.value || Number(bleState.chargeStatus.value) === 0x10) {
            showAlert('충전 중에는 통증 측정을 실행할 수 없습니다.')
            return
        }

        // 이미 결과값이 있으면 재검 방지
        if (type === 'cpt') {
            const value = Number(cptMeasurements.value[index].value)

            if (value > 0) {
                const result = await confirm(
                    `${index + 1}회차에 기존 결과가 있습니다.\n삭제하고 다시 검사하시겠습니까?`
                )
                if (!result) return

                cptMeasurements.value[index].value = 0
            }
        } else if (type === 'pec') {
            const value = Number(pecMeasurements.value[index].value)

            if (value > 0) {
                const result = await confirm(
                    `${index + 1}회차에 기존 결과가 있습니다.\n삭제하고 다시 검사하시겠습니까?`
                )
                if (!result) return

                pecMeasurements.value[index].value = 0
            }
        }

        // 이미 다른 검사(또는 다른 index)가 실행 중이면 막기
        if (runningType.value !== null) {
            // 같은 type/같은 index를 또 누른 경우는 무시(원하면 showAlert도 가능)
            if (runningType.value === type && runningIndex.value === index) return

            showAlert('검사가 진행 중입니다. STOP 후 다시 시도해주세요.')
            return
        }

        const currentLimitValue = currentLimit.value === 'custom' ? !!customCurrent.value : currentLimit.value !== null && currentLimit.value !== '';
        const vLimit            = voltageLimit.value === 'custom' ? customVoltage.value : voltageLimit.value;
        const setTimeValue      = setTime.value === 'custom' ? !!customSetTime.value : setTime.value !== null && setTime.value !== '';

        // 타입별 필요한 시간값 검사
        if (!currentLimitValue) {
            showAlert('Current Limit 값을 설정해주세요.');
            return;
        }
        if (!vLimit) {
            showAlert('vLimit 값을 설정해주세요.');
            return;
        }
        if (!setTimeValue) {
            showAlert('시간을 설정해주세요.');
            return;
        }
        if (type === 'cpt') {
            cptReceiveIndex.value = index
        } else {
            pecReceiveIndex.value = index
        }

        // 실제 시간 측정 시작 시각 기록
        const now = Date.now();
        if (type === 'cpt') {
            cptStartAt.value[index] = now;
            cptDurations.value[index] = 0; // 재측정이면 초기화
        } else {
            pecStartAt.value[index] = now;
            pecDurations.value[index] = 0;
        }

        // BLE 메시지 생성
        const currentValue = currentLimit.value === 'custom' ? customCurrent.value : currentLimit.value;
        const voltageValue = voltageLimit.value === 'custom' ? customVoltage.value : voltageLimit.value;
        const timeValue    = setTime.value === 'custom' ? customSetTime.value : setTime.value
        const gubun        = 'D';
        const isActive     = 1;
        const uA           = currentValue;
        const V            = voltageValue;
        const ms           = Number(timeValue);
        const Hz           = 50;
        const limitMs      = Number(ms) * 1000;

        globalMsg.value  = `(${gubun},${isActive},${uA},${V},${ms},${Hz})CRLF`;

        status.value     = 'start'
        activeType.value = type
        timeMs.value     = ms * 1000

        // bleActions.sendMessage(globalMsg.value)

        const high   = Math.floor(uA / 256)
        const low    = uA % 256;
        const result = convertUtils.generateBLEArray(1, 2, high, low, V, ms)
        count.value++
        ctrlCount.value = 1
        bleActions.sendMessage(result)

        // 무응답 시 추가
        const retryInterval = setInterval(() => {
            if(ctrlCount.value > 0){
                const retry = convertUtils.generateBLEArray(1, 2, high, low, V, ms)
                bleActions.sendMessage(retry)
            }
        }, 200)
        setTimeout(() => {
            if (retryInterval) {
                clearInterval(retryInterval);
                bleActions.enableBack()
            }
        }, 1050);

        // 실행중 상태 기록
        runningType.value  = type
        runningIndex.value = index

        const hardTimeoutHandler = () => {
            // 이미 끝났으면 무시
            if (runningType.value !== type || runningIndex.value !== index) return

            const maxCurrent = getCurrentLimitValueNumber()
            if (maxCurrent <= 0) {
                showAlert('Current Limit 값이 올바르지 않습니다.')
                return
            }

            // timeout 종료는 stop 상태로 정리
            status.value = 'stop'
            activeType.value = type

            if (type === 'cpt') {
                // 회차별 최종값: (1) 해당 input 마지막값 (2) 전역 마지막값 (3) maxCurrent
                const lastInThisRound = Number(cptMeasurements.value[index]?.value) || 0
                const lastGlobal = Number(cptLastValue.value) || 0
                const finalValue =
                lastInThisRound > 0 ? lastInThisRound : (lastGlobal > 0 ? lastGlobal : maxCurrent)

                cptReceiveIndex.value = index
                cptMeasurements.value[index].value = finalValue
                showAlert(`C.P.T ${index + 1}회차 검사 완료 (시간 초과 자동 종료)\n측정값: ${finalValue} μA`)
                cptActive.value[index] = false

                // 완료 처리
                cptPopupComplete.value = index
                cptPopupStep.value = cptPopupComplete.value + 3

                // duration은 설정시간으로 강제 기록
                finalizeDuration('cpt', index, limitMs)
            } else {
                // PEC도 CPT와 동일한 방식으로
                const lastInThisRound = Number(pecMeasurements.value[index]?.value) || 0
                const lastGlobal = Number(pecLastValue.value) || 0
                const finalValue =
                lastInThisRound > 0 ? lastInThisRound : (lastGlobal > 0 ? lastGlobal : maxCurrent)

                pecReceiveIndex.value = index
                pecMeasurements.value[index].value = finalValue
                showAlert(`P.E.C ${index + 1}회차 검사 완료 (시간 초과 자동 종료)\n측정값: ${finalValue} μA`)
                pecActive.value[index] = false

                // 완료 처리(PEC 팝업/진행상태 반영)
                pecPopupComplete.value = index
                pecPopupStep.value = pecPopupComplete.value + 3

                // duration은 설정시간으로 강제 기록
                finalizeDuration('pec', index, limitMs)
            }

            // 장비 정지 신호
            sendStopSignal(type)

            // 실행 상태 해제
            runningType.value = null
            runningIndex.value = null

            clearHardTimer(type)
            clearStreamTimer(type)

            // 필요하면 알림
            // showAlert('설정 시간 초과로 자동 종료되었습니다.')
        }

        if (type === 'cpt') cptHardTimer.value = setTimeout(hardTimeoutHandler, limitMs) 
        else pecHardTimer.value = setTimeout(hardTimeoutHandler, limitMs) 
    }

    function stopMeasurement(type, index) {
        if(!bleState.deviceConnected.value || !bleState.isReady.value){
            showAlert('장비가 연결되어 있지 않거나 통신 준비가 되지 않았습니다.')
            return
        }

        // STOP 누르면 하드 타임아웃은 즉시 해제(중복 실행 방지)
        clearHardTimer(type) 
        clearStreamTimer(type)

        if (type === 'cpt') {
            cptReceiveIndex.value = index
        } else {
            pecReceiveIndex.value = index
        }

        // BLE 측정 중지 메시지 전송
        const gubun     = 'D';  // 데이터 구분 (D: 진단기)
        const isActive  = 0;    // 0은 정지 신호
        const uA        = currentLimit.value === 'custom' ? customCurrent.value : currentLimit.value;
        const V         = voltageLimit.value === 'custom' ? customVoltage.value : voltageLimit.value; // 전압 고정값
        const ms        = setTime.value === 'custom' ? customSetTime.value : setTime.value
        const Hz        = 50; // 주파수 고정값
        const msg       = `(${gubun},${isActive},${uA},${V},${ms},${Hz})CRLF`;

        status.value     = 'stop'
        activeType.value = type
        checkError.value = false
        // bleActions.sendMessage(msg)

        const result = convertUtils.generateBLEArray(1, 1, 0)
        count.value++
        stopCount.value = 1
        bleActions.sendMessage(result)

        // 무응답 시 추가
        const retryInterval = setInterval(() => {
            if(stopCount.value > 0){
                const retry = convertUtils.generateBLEArray(1, 1, 0)
                bleActions.sendMessage(result)
            }
        }, 200)
        setTimeout(() => {
            if (retryInterval) {
                clearInterval(retryInterval);
                bleActions.enableBack()
            }
        }, 1050);

        // 실행중 상태 해제
        runningType.value  = null
        runningIndex.value = null
    }

    function sendStopSignal(type) {
        const gubun     = 'D'; // 데이터 구분 (D: 진단기)
        const isActive  = 0; // 정지 신호
        const uA        = currentLimit.value === 'custom' ? customCurrent.value : currentLimit.value;
        const V         = voltageLimit.value === 'custom' ? customVoltage.value : voltageLimit.value;
        const ms        = setTime.value === 'custom' ? customSetTime.value : setTime.value;
        const Hz        = 50;
        const msg       = `(${gubun},${isActive},${uA},${V},${ms},${Hz})CRLF`;

        // bleActions.sendMessage(msg)
        const result = convertUtils.generateBLEArray(1, 1, 0)
        count.value++
        stopCount.value = 1
        bleActions.sendMessage(result)

        // 무응답 시 추가
        const retryInterval = setInterval(() => {
            if(stopCount.value > 0){
                const retry = convertUtils.generateBLEArray(1, 1, 0)
                bleActions.sendMessage(result)
            }
        }, 200)
        setTimeout(() => {
            if (retryInterval) {
                clearInterval(retryInterval);
                bleActions.enableBack()
            }
        }, 1050);
    }

    const isSaveEnabled = computed(() => {
        // 필수 조건들
        const hasPainArea       = selectedFront.value.length > 0;
        const currentLimitValue = currentLimit.value === 'custom' ? !!customCurrent.value : currentLimit.value !== null && currentLimit.value !== '';
        const voltageLimitValue = voltageLimit.value === 'custom' ? !!customVoltage.value : voltageLimit.value !== null && voltageLimit.value !== '';
        const setTimeValue      = setTime.value === 'custom' ? !!customSetTime.value : setTime.value !== null && setTime.value !== '';

        const hasAllCptValues   = cptMeasurements.value.every(v => Number(v.value) > 0);  // 여기 수정
        const hasAllPecValues   = pecMeasurements.value.every(v => Number(v.value) > 0);

        const hasVAS            = !!vasValue.value;

        return (
            hasPainArea &&
            currentLimitValue &&
            voltageLimitValue &&
            setTimeValue&&
            hasAllCptValues &&
            hasAllPecValues &&
            hasVAS
        );
    });

    function onCategoryChange() {
        selectedDisease.value = '' // 카테고리 변경 시 세부 진단명 초기화
    }

    async function Save() {
        if (runningType.value !== null) {
            showAlert('검사가 진행 중입니다. 검사가 종료된 후 저장해주세요.')
            return
        }

        const ok = await confirm("정말로 저장하시겠습니까?");
        if (!ok) { 
            return;
        }

        // 전송할 데이터 매핑
        const payload = {
            patientId   : patientInfo.value.id,
            painArea    : selectedFront.value.length > 0
                ? getDisplayLabels(selectedFront.value, bodyName)
                : '',
            vasScore     : vasValue.value,
            currentLimit : currentLimit.value === 'custom' ? customCurrent.value : currentLimit.value,
            voltageLimit : voltageLimit.value === 'custom' ? customVoltage.value : voltageLimit.value,
            setTime      : setTime.value === 'custom' ? customSetTime.value : setTime.value,
            cptTime      : cptAvgTimeSec.value,  
            pecTime      : pecAvgTimeSec.value,
            cptValue1    : cptMeasurements.value[0].value,
            cptValue2    : cptMeasurements.value[1].value,
            cptValue3    : cptMeasurements.value[2].value,
            cptMean      : cptMean.value,
            pecValue1    : pecMeasurements.value[0].value,
            pecValue2    : pecMeasurements.value[1].value,
            pecValue3    : pecMeasurements.value[2].value,
            pecMean      : pecMean.value,
            score        : resultInfo.value.score,
            category     : selectedCategory.value || '',
            comment      : comment.value || ''
        };

        // 저장 요청
        api.post(urls.patientList.diagnosisSave, payload)
            .then(() => {
                showAlert("저장되었습니다.");
                router.push({
                    path: `/patientlist/diagnosisHistory/${patientInfo.value.id}`
                });
            })
            .catch((err) => {
                showAlert("저장에 실패했습니다. 다시 시도해주세요.");
            });
    }

    function recordMeasurementEvent(eventType) {
        const authStore = useAuthStore();
        
        api.post(urls.patientList.recordEvent, {
            email: authStore.getUser?.email || 'unknown_user',
            deviceName: commonUtils.getDeviceInfo(),
            eventType,
            eventTime: new Date().toISOString()
        })
            .catch(err => {});
    }

    async function handlePrevClick() {

        // ✅ 1. 검사 결과 존재 여부 체크
        const hasCptResult = cptMeasurements.value.some(v => Number(v.value) > 0)
        const hasPecResult = pecMeasurements.value.some(v => Number(v.value) > 0)

        const hasAnyResult = hasCptResult || hasPecResult

        // ✅ 2. 결과가 하나라도 있으면 confirm
        if (hasAnyResult) {
            const ok = await confirm("지금까지의 검사 결과를 초기화하고 이전 단계로 이동하시겠습니까?")
            if (!ok) return
        }

        // ============================
        // 초기화 로직
        // ============================

        // CPT 초기화
        cptMeasurements.value.forEach(v => v.value = 0)
        cptActive.value     = [false, false, false]
        cptDurations.value  = [0, 0, 0]
        cptStartAt.value    = [null, null, null]
        cptSeries.value     = []

        // PEC 초기화
        pecMeasurements.value.forEach(v => v.value = 0)
        pecActive.value     = [false, false, false]
        pecDurations.value  = [0, 0, 0]
        pecStartAt.value    = [null, null, null]
        pecSeries.value     = []

        // 평균 / 점수 초기화
        resultInfo.value.score = 0

        // 실행 상태 초기화
        runningType.value  = null
        runningIndex.value = null
        clearHardTimer('cpt')
        clearHardTimer('pec')
        clearStreamTimer('cpt')
        clearStreamTimer('pec')

        // 단계 이동
        step.value = 1
    }

    function closeKeyboard(targetRef = null) {
        if (targetRef?.value) {
            targetRef.value.blur()
            return
        }

        const activeEl = document.activeElement
        if (activeEl && typeof activeEl.blur === 'function') {
            activeEl.blur()
        }
    }

    async function focusVoltageInput() {
        await nextTick()
        voltageInputRef.value?.focus()
    }

    async function focusTimeInput() {
        await nextTick()
        timeInputRef.value?.focus()
    }

    async function handleCurrentInputEnter() {
        // 다음 우선순위: voltage custom -> time custom -> 키보드 닫기
        if (voltageLimit.value === 'custom') {
            await focusVoltageInput()
            return
        }

        if (setTime.value === 'custom') {
            await focusTimeInput()
            return
        }

        closeKeyboard(currentInputRef)
    }

    async function handleVoltageInputEnter() {
        // 다음 우선순위: time custom -> 키보드 닫기
        if (setTime.value === 'custom') {
            await focusTimeInput()
            return
        }

        closeKeyboard(voltageInputRef)
    }

    function handleTimeInputEnter() {
        closeKeyboard(timeInputRef)
    }

    const backgroundStopAlerted = ref(false)
    function stopRunningMeasurementByBackground() {
        if (runningType.value === null || runningIndex.value === null) return

        const type = runningType.value
        const index = runningIndex.value

        // 타이머 정리
        clearHardTimer(type)
        clearStreamTimer(type)

        // 현재 검사중인 회차 초기화
        if (type === 'cpt') {
            cptActive.value[index] = false
            cptReceiveIndex.value = index
            cptMeasurements.value[index].value = 0
            cptStartAt.value[index] = null
            cptDurations.value[index] = 0
            cptLastValue.value = 0
        } else if (type === 'pec') {
            pecActive.value[index] = false
            pecReceiveIndex.value = index
            pecMeasurements.value[index].value = 0
            pecStartAt.value[index] = null
            pecDurations.value[index] = 0
            pecLastValue.value = 0
        }

        // 장비 정지 신호 전송
        sendStopSignal(type)

        // 실행 상태 해제
        status.value = 'stop'
        activeType.value = type
        runningType.value = null
        runningIndex.value = null

        if (!backgroundStopAlerted.value) {
            backgroundStopAlerted.value = true
            showAlert('검사가 중지되었습니다.') // 백그라운드 실행 시
            setTimeout(() => {
                backgroundStopAlerted.value = false
            }, 1000)
        }
    }

    // watch(
    //     [cptMean, pecMean, setTime, customSetTime, currentLimit, customCurrent],
    //     ([newCptMean, newPecMean, newSetTime, newCustomSetTime]) => {
    //         if (!chartInstance) return;

    //         // 선택된 시간 값 반영 (커스텀인 경우 입력값으로, 아니면 라디오 값)
    //         const setTimeX = newSetTime === 'custom' ? Number(newCustomSetTime) || 0 : Number(newSetTime);

    //         chartInstance.data.datasets = [
    //             {
    //                 label: 'C.P.T',
    //                 data: [{ x: Number(cptAvgTimeSec.value), y: Number(newCptMean) }],
    //                 backgroundColor: '#fa6262',
    //                 pointRadius: 13,
    //                 pointHoverRadius: 18
    //             },
    //             {
    //                 label: 'P.E.C',
    //                 data: [{ x: Number(pecAvgTimeSec.value), y: Number(newPecMean) }],
    //                 backgroundColor: '#239cff',
    //                 pointRadius: 15,
    //                 pointHoverRadius: 18
    //             }
    //         ];
    //         const yMax =
    //             currentLimit.value === 'custom'
    //                 ? Number(customCurrent.value) || 0
    //                 : Number(currentLimit.value);

    //         chartInstance.options.scales.y.max = yMax;

    //         chartInstance.update();

    //         // 평균 점수도 지속 업데이트
    //         const score = calculateScore(newCptMean, newPecMean);
    //         resultInfo.value.score = score;
    //     },
    //     { immediate: true }
    // );
    // watch 외부 상단에 선언
    let isChartUpdating = false;

    const requestChartUpdate = () => {
        if (isChartUpdating) return;
        isChartUpdating = true;
        
        // 프레임 최적화 (약 0.1~0.2초마다 한 번씩만 그리도록 제한)
        setTimeout(() => {
            if (chartInstance) chartInstance.update('none'); // 'none' 옵션으로 애니메이션 제거하면 더 가벼움
            isChartUpdating = false;
        }, 200); 
    };
    watch(
        [cptMean, pecMean, setTime, customSetTime, currentLimit, customCurrent],
        ([newCptMean, newPecMean, newSetTime, newCustomSetTime]) => {
            if (!chartInstance) return;

            // 1. 차트 데이터셋 업데이트 (메모리상의 데이터만 변경)
            const setTimeX = newSetTime === 'custom' ? Number(newCustomSetTime) || 0 : Number(newSetTime);

            chartInstance.data.datasets[0].data = [{ x: Number(cptAvgTimeSec.value), y: Number(newCptMean) }];
            chartInstance.data.datasets[1].data = [{ x: Number(pecAvgTimeSec.value), y: Number(newPecMean) }];

            const yMax = currentLimit.value === 'custom'
                ? Number(customCurrent.value) || 0
                : Number(currentLimit.value);
            chartInstance.options.scales.y.max = yMax;

            // 2. 실제 렌더링 요청 (직접 update() 대신 위에 만든 함수 호출)
            requestChartUpdate();

            // 3. 점수 계산 (차트와 별개로 처리)
            resultInfo.value.score = calculateScore(newCptMean, newPecMean);
        },
        { immediate: true }
    );

    const handleNGReceived = () => {
        // START 실패 처리
        if (status.value === 'start') {
            showAlert('측정 시작에 실패했습니다. 다시 시도해주세요.')
            
            const index = activeType.value === 'cpt' ? cptReceiveIndex.value : pecReceiveIndex.value
            
            if (activeType.value === 'cpt' && index !== null) {
                if (cptStreamTimer.value) {
                    clearTimeout(cptStreamTimer.value)
                    cptStreamTimer.value = null
                }
                cptActive.value[index] = false
            } else if (activeType.value === 'pec' && index !== null) {
                if (pecStreamTimer.value) {
                    clearTimeout(pecStreamTimer.value)
                    pecStreamTimer.value = null
                }
                pecActive.value[index] = false
            }
        }
        // STOP 실패 처리 - 버튼 활성 상태 유지
        else if (status.value === 'stop') {
            checkError.value = true
            showAlert('중지 신호가 전달되지 않았습니다. STOP 버튼을 다시 눌러주세요.')
            
            // 인덱스 먼저 확인
            const index = activeType.value === 'cpt' ? cptReceiveIndex.value : pecReceiveIndex.value
            
            // 버튼 활성 상태 유지 (인덱스 유지하고 active만 true)
            if (activeType.value === 'cpt' && index !== null) {
                cptActive.value[index] = true
            } else if (activeType.value === 'pec' && index !== null) {
                pecActive.value[index] = true
            }
            status.value = 'start'
        }
    }

    // 정상 데이터 처리 수정
    let padError = false
    const handleDataReceived = (event) => {

        if (runningType.value === null || !event.detail) return;

        const data = event.detail
        
        const type = data[1]
        // 실시간(0x01) & 확정 데이터(0x02) & 정상(0x55)
        const current = data[2]
        const value   = Number((data[3] * 256) + data[4])
        // const value   = Number((data[4] * 256) + data[3])  // little-endian 파싱

        const currentIndex = activeType.value === 'cpt' ? cptReceiveIndex.value : pecReceiveIndex.value;
        if (currentIndex === null) return;

        ctrlCount.value  = 0
        startCount.value = 0
        stopCount.value  = 0

        if (type == 0x00 || type == 0x01) {
            padError = false
            // START 성공 처리
            if (status.value === 'start') {
                bleActions.disableBack()
                // 시작
                if(count.value > 0){
                    const result = convertUtils.generateBLEArray(1, 1, 1)
                    bleActions.sendMessage(result)
                    startCount.value = 1

                    // 무응답 시 추가
                    const retryInterval = setInterval(() => {
                        if(startCount.value > 0){
                            const retry = convertUtils.generateBLEArray(1, 1, 1)
                            bleActions.sendMessage(result)
                        }
                    }, 200)
                    setTimeout(() => {
                        if (retryInterval) {
                            clearInterval(retryInterval);
                            bleActions.enableBack()
                        }
                    }, 1050);

                    recordMeasurementEvent('painDeviceStart');
                    count.value--
                }else if(current == 0x02){
                    // 확정 전류(물리 종료)
                    const result = convertUtils.generateBLEArray(1, 0x55)
                    bleActions.sendMessage(result)

                    status.value     = 'stop'
                    checkError.value = false

                    if (activeType.value === 'cpt') {
                        finalizeDuration('cpt', cptReceiveIndex.value)
                        clearStreamTimer('cpt')                        
                        clearHardTimer('cpt')                         
                        cptMeasurements.value[cptReceiveIndex.value].value = value
                        cptLastValue.value = value
                        cptActive.value[cptReceiveIndex.value] = false
                        showAlert(`C.P.T ${cptReceiveIndex.value + 1}회차 검사 완료\n측정값: ${value} μA`)
                        cptPopupComplete.value = cptReceiveIndex.value
                        cptPopupStep.value = cptPopupComplete.value + 3
                        stopMeasurement(activeType.value, startCount.value)
                    } else if (activeType.value === 'pec') {
                        finalizeDuration('pec', pecReceiveIndex.value) 
                        clearStreamTimer('pec')                       
                        clearHardTimer('pec')                         
                        pecMeasurements.value[pecReceiveIndex.value].value = value
                        pecLastValue.value = value
                        pecActive.value[pecReceiveIndex.value] = false
                        showAlert(`P.E.C ${pecReceiveIndex.value + 1}회차 검사 완료\n측정값: ${value} μA`)
                        pecPopupComplete.value = pecReceiveIndex.value
                        pecPopupStep.value = pecPopupComplete.value + 3
                        stopMeasurement(activeType.value, startCount.value)
                    }
                }else{
                    if (activeType.value === 'cpt') {
                        clearStreamTimer('cpt') // 기존 cptMeasurementTimer 역할

                        cptActive.value[cptReceiveIndex.value] = true
                        // cptMeasurements.value[cptReceiveIndex.value].value = value
                        // 블루투스 연결 코드상 00 00 이면 256으로 인식 
                        // 전류가 256까지 올라가지 않으므로 value가 256일 경우 0으로 인식하도록 수정 임시방편으로 추후 수정 필요
                        if (value == 256) {
                            cptMeasurements.value[cptReceiveIndex.value].value = 0
                        } else {
                            cptMeasurements.value[cptReceiveIndex.value].value = value
                        }
                        cptLastValue.value = value

                        cptStreamTimer.value = setTimeout(() => {
                            sendStopSignal('cpt')
                            cptStreamTimer.value = null

                            // 현재까지 수신된 값 그대로 사용
                            const idx = cptReceiveIndex.value
                            const currentValue = Number(cptMeasurements.value[idx].value) // 마지막 수신값 유지

                            // duration은 설정시간으로 기록
                            const limitSec =
                                setTime.value === 'custom'
                                    ? Number(customSetTime.value)
                                    : Number(setTime.value)

                            finalizeDuration('cpt', idx, limitSec * 1000) // 강제 duration

                            status.value = 'stop'
                            cptMeasurements.value[idx].value = currentValue // 그대로 확정
                            cptActive.value[idx] = false
                            cptPopupComplete.value = idx
                            cptPopupStep.value = cptPopupComplete.value + 3
                        }, 500)

                    } else if (activeType.value === 'pec') {
                        clearStreamTimer('pec') // ✅ 수정

                        pecActive.value[pecReceiveIndex.value] = true
                        // pecMeasurements.value[pecReceiveIndex.value].value = value
                        if (value == 256) {
                            pecMeasurements.value[pecReceiveIndex.value].value = 0
                        } else {
                            pecMeasurements.value[pecReceiveIndex.value].value = value
                        }
                        pecLastValue.value = value

                        pecStreamTimer.value = setTimeout(() => {
                            sendStopSignal('pec')
                            pecStreamTimer.value = null

                            // 현재까지 수신된 값 그대로 사용
                            const idx = pecReceiveIndex.value
                            const currentValue = Number(pecMeasurements.value[idx].value)

                            // duration은 설정시간으로 기록
                            const limitSec =
                                setTime.value === 'custom'
                                    ? Number(customSetTime.value)
                                    : Number(setTime.value)

                            finalizeDuration('pec', idx, limitSec * 1000) // 강제 duration

                            status.value = 'stop'
                            pecMeasurements.value[idx].value = currentValue
                            pecActive.value[idx] = false
                            pecPopupComplete.value = idx
                            pecPopupStep.value = pecPopupComplete.value + 3
                        }, 500)
                    }
                }
            }
            // STOP 성공 처리
            else if (status.value === 'stop') {
                bleActions.enableBack()
                if(type == 0x00){
                    // pad 에러 해결
                    const result = convertUtils.generateBLEArray(1, 0x55)
                    bleActions.sendMessage(result)
                }else if(current == 0x55 && count.value > 0){
                    // 정지
                    recordMeasurementEvent('painDeviceStop');
                    count.value--

                    setTimeout(() => {
                        if(!checkError.value) showAlert('측정이 중지되었습니다.')
                    }, 300);
                }else if(current == 0x02){
                    // 확정 전류
                    const result = convertUtils.generateBLEArray(1, 0x55)
                    bleActions.sendMessage(result)

                    if (activeType.value === 'cpt') {
                        finalizeDuration('cpt', cptReceiveIndex.value) 
                        clearStreamTimer('cpt')                        
                        clearHardTimer('cpt')                          
                        cptActive.value[cptReceiveIndex.value] = false
                        cptMeasurements.value[cptReceiveIndex.value].value = value
                        showAlert(`C.P.T ${cptReceiveIndex.value + 1}회차 검사 완료\n측정값: ${value} μA`)
                        cptPopupComplete.value = cptReceiveIndex.value
                        cptPopupStep.value = cptPopupComplete.value + 3
                    } else if (activeType.value === 'pec') {
                        finalizeDuration('pec', pecReceiveIndex.value) 
                        clearStreamTimer('pec')                        
                        clearHardTimer('pec')                          
                        pecMeasurements.value[pecReceiveIndex.value].value = value
                        showAlert(`P.E.C ${pecReceiveIndex.value + 1}회차 검사 완료\n측정값: ${value} μA`)
                        pecActive.value[pecReceiveIndex.value] = false
                        pecPopupComplete.value = pecReceiveIndex.value
                        pecPopupStep.value = pecPopupComplete.value + 3
                    }
                }
            }
        } else {
            // 에러 처리(기존 흐름 유지) + 타이머 정리
            if (activeType.value === 'cpt') {
                clearStreamTimer('cpt') 
                clearHardTimer('cpt')   
                cptActive.value[cptReceiveIndex.value] = false
            } else if (activeType.value === 'pec') {
                clearStreamTimer('pec') 
                clearHardTimer('pec')   
                pecActive.value[pecReceiveIndex.value] = false
            }

            if(type == 0xaa && !padError){
                const result = convertUtils.generateBLEArray(1, 0x55)
                bleActions.sendMessage(result)
                status.value = 'stop'
                checkError.value = false

                setTimeout(() => {
                    showAlert('측정기 PAD가 빠졌습니다. 다시 연결해주시길 바랍니다.')
                    recordMeasurementEvent('painDeviceError')
                    const index = activeType.value === 'cpt' ? cptReceiveIndex.value : pecReceiveIndex.value
                    stopMeasurement(activeType.value, index)
                    padError = true
                }, 200);
            }
        }
    }

    const nextStep = (val) => {
        // 개발 테스트
        // if(val == 2){
        //     if(!bleState.deviceConnected.value && !bleState.isReady.value){
        //         showAlert('장비가 연결되어 있지 않거나 통신 준비가 되지 않았습니다.')
        //         return
        //     }
        //     if(selectedFront.value.length == 0){
        //         showAlert('통증 부위를 선택해주세요.')
        //         return
        //     }
        //     if(!vasValue.value){
        //         showAlert('VAS를 선택해주세요.')
        //         return
        //     }
        // }else if(val == 2){
        //     if(!bleState.deviceConnected.value && !bleState.isReady.value){
        //         showAlert('장비가 연결되어 있지 않거나 통신 준비가 되지 않았습니다.')
        //         return
        //     }
        // }
        // 개발 테스트
        step.value = val
    }

    const openCptPopup = () => {
        if ( currentLimit.value === 'custom' && (customCurrent.value < 0 || customCurrent.value > currentLimitMax)){
            showAlert('current limit 값을 0~'+currentLimitMax+' 사이의 값으로 정확히 입력하세요.');
            return;
        }
        if ( voltageLimit.value === 'custom' && (voltageLimit.value < 0 || voltageLimit.value > voltageLimitMax) ){
            showAlert('voltage limit 값을 0~'+voltageLimitMax+' 사이의 값으로 정확히 입력하세요.');
            return;
        }
        if ( setTime.value === 'custom' && (customSetTime.value < 30 || customSetTime.value > 150)) {
            showAlert(`C.P.T & P.E.C Time 값을 30~150 사이의 값으로 정확히 입력하세요. 입력값: ${customSetTime.value}`);
            return;
        }

        if(cptPopupComplete.value > -1){
            cptPopupStep.value = cptPopupComplete.value + 3
        }
        cptPopupStatus.value = true
    }

    const closeCptPopup = () => {
        cptPopupStatus.value = false
    }

    const openPecPopup = () => {
        if ( currentLimit.value === 'custom' && (customCurrent.value < 0 || customCurrent.value > currentLimitMax)){
            showAlert('current limit 값을 0~'+currentLimitMax+' 사이의 값으로 정확히 입력하세요.');
            return;
        }
        if ( voltageLimit.value === 'custom' && (customVoltage.value < 0 || customVoltage.value > voltageLimitMax) ){
            showAlert('voltage limit 값을 0~'+voltageLimitMax+' 사이의 값으로 정확히 입력하세요.');
            return;
        }
        if ( pecTime.value === 'custom' && (customPecTime.value < 30 || customPecTime.value > 150)) {
            showAlert('P.E.C Time 값을 30~150 사이의 값으로 정확히 입력하세요.');
            return;
        }

        if(pecPopupComplete.value > -1){
            pecPopupStep.value = pecPopupComplete.value + 3
        }
        pecPopupStatus.value = true
    }
    const closePecPopup = () => {
        pecPopupStatus.value = false
    }

    const stopMsg = () => {
        if(globalMsg.value.split(',')[1] == '1' && bleState.deviceConnected.value && bleState.isReady.value && status.value == 'start') {
            const result = convertUtils.generateBLEArray(1, 1, 0)
            bleActions.sendMessage(result)
            bleActions.enableBack()
            stopCount.value = 1

            // 무응답 시 추가
            const retryInterval = setInterval(() => {
                if(stopCount.value > 0){
                    const retry = convertUtils.generateBLEArray(1, 1, 0)
                    bleActions.sendMessage(result)
                }
            }, 200)
            setTimeout(() => {
                if (retryInterval) {
                    clearInterval(retryInterval);
                }
            }, 1050);
        }
    }

    const handleBatteryStatusChanged = (event) => {
        const newStatus = Number(event.detail?.chargeStatus ?? 0);
        bleState.chargeStatus.value = newStatus;
        bleState.isCharging.value = !!event.detail?.isCharging;

        // 충전기 연결(0x10) 시 검사가 진행 중이면 초기화
        if (newStatus === 0x10 && runningType.value !== null) {
            showAlert('충전기가 연결되었습니다. 안전을 위해 진행 중인 모든 검사 내역을 초기화합니다.');
            sendStopSignal(runningType.value);
            resetAllMeasurements(); // 전체 초기화 함수 호출
        }
    }

    const handleTargetTxReceived = (event) => {
        const packet = event.detail?.packet || []

        console.log('78 0A 10 헤더 수신:', packet)

        bleState.chargeStatus.value = 0x10
        bleState.isCharging.value = true

        if (status.value === 'start' && runningType.value !== null) {
            sendStopSignal(runningType.value);
            resetAllMeasurements();
            showAlert('충전이 감지되어 검사를 중단하고 초기화합니다.');
        }
        recordMeasurementEvent('targetTxReceived', { measurementValues: packet }, 'R')
    }

    function handleAppBackground() {
        // 검사 중이 아니면 무시
        if (runningType.value === null || runningIndex.value === null) return

        // document.hidden === true 이면 백그라운드 상태
        if (document.hidden) {
            stopRunningMeasurementByBackground()
        }

        const type = runningType.value
        const index = runningIndex.value

        // 타이머 먼저 정리
        clearHardTimer(type)
        clearStreamTimer(type)

        // 진행 상태 off
        if (type === 'cpt') {
            cptActive.value[index] = false
            cptReceiveIndex.value = index
        } else if (type === 'pec') {
            pecActive.value[index] = false
            pecReceiveIndex.value = index
        }

        // duration 기록
        finalizeDuration(type, index)

        // 장비 정지 신호 전송
        sendStopSignal(type)

        // 실행 상태 해제
        runningType.value = null
        runningIndex.value = null
        status.value = 'stop'
        activeType.value = type

        showAlert('백그라운드 상태로 전환되어 검사 진행이 중단되었습니다.')
    }

    onMounted(() => {
        const idFromRoute = route.params.patientId;
        PatientData(idFromRoute);  // 환자 프로필 세팅

        chartInstance = new Chart(chartCanvas.value, {
            type: 'scatter',
            data: {
                datasets: [
                    {
                        label: 'C.P.T',
                        data: [{ x: Number(cptAvgTimeSec.value), y: Number(cptMean.value) }],
                        backgroundColor: '#fa6262',
                        pointRadius: 13,
                        pointHoverRadius: 18
                    },
                    {
                        label: 'P.E.C',
                        data: [{ x: Number(pecAvgTimeSec.value), y: Number(pecMean.value) }],
                        backgroundColor: '#239cff',
                        pointRadius: 15,
                        pointHoverRadius: 18
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                x: { title: { display: true, text: '(sec)', align: 'end' }, min: 0, grid: { color: '#dde8f0' } },
                y: {
                    min: 0,
                    max: Number(currentLimit.value),      
                    grid: { color: '#dde8f0' }
                }
                },
                plugins: {
                legend: { display: true, position: 'left' },
                tooltip: {
                    enabled: true,
                    callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ${context.parsed.y}`;
                    }
                    }
                },
                datalabels: { display: false }
                }
            }
        });

        window.addEventListener('ble-ng-received', handleNGReceived)
        window.addEventListener('ble-data-received', handleDataReceived)
        window.addEventListener('beforeunload', stopMsg)
        window.addEventListener('ble-target-tx-received', handleTargetTxReceived)

        document.addEventListener('visibilitychange', handleAppBackground)
        window.addEventListener('pagehide', stopRunningMeasurementByBackground)
    })

    onBeforeUnmount(() => {
        window.removeEventListener('ble-ng-received', handleNGReceived)
        window.removeEventListener('ble-data-received', handleDataReceived)
        window.removeEventListener('beforeunload', stopMsg)
        window.removeEventListener('ble-target-tx-received', handleTargetTxReceived)

        document.removeEventListener('visibilitychange', handleAppBackground)
        window.removeEventListener('pagehide', stopRunningMeasurementByBackground)
        stopMsg()

        clearStreamTimer('cpt')
        clearStreamTimer('pec')
        clearHardTimer('cpt')
        clearHardTimer('pec')
    })


    //parts length 기준으로 정렬을 한번 해,
    //해당되는게 있으면 break,
    //하고 다음 부위 진행

    function getDisplayLabels(selected, labels) {
        let usedparts    = new Set();
        let resultLabels = [];
        // 1. length 내림차순으로 정렬(더 큰 그룹 우선)
        const sortedGroups = [...PAIR_GROUPS].sort((a, b) => b.parts.length - a.parts.length);
        // 2. 그룹별로 순회
        for (const group of sortedGroups) {
            // 이미 처리된 인덱스 건너뛰고, 현재 선택된 것과 매칭
            if (group.parts.every(idx => selected.includes(idx) && !usedparts.has(idx))) {
                resultLabels.push(group.groupName);
                group.parts.forEach(idx => usedparts.add(idx));
            }
        }
        // 3. 그룹에 포함 안 된 개별 표기도 추가
        for (const idx of selected) {
            if (!usedparts.has(idx)) {
                resultLabels.push(labels[idx]);
            }
        }
        return resultLabels.join(', ');
    }

    const inputsMap = {
        customCurrent: { ref: customCurrent, min: 30,  max: currentLimitMax },
        customVoltage: { ref: customVoltage, min: 1.5,  max: 200 },
        customSetTime: { ref: customSetTime, min: 30, max: 150 },
    };

    function onBlurNumberInput(e, inputKey) {
        const { ref: modelRef, min, max } = inputsMap[inputKey];
        if (!modelRef) return;

        let val = Number(e.target.value);
        if (val < min || val > max) {
            showAlert(`입력한 값은 ${min}에서 ${max} 사이여야 합니다. 해당 범위 안에 숫자를 입력해주세요.`);
            // 값을 최소 또는 최대값으로 강제 수정
            if (val < min) val = min;
            if (val > max) val = max;
        }

        modelRef.value = val;
        e.target.value = val;
    }

    const alerted = ref(false)  // 중복 alert 방지용 플래그

    watch(
        () => bleState.chargeStatus.value,
        (newStatus) => {
            if (Number(newStatus) === 0x10 && runningType.value !== null) {
                showAlert('충전 중에는 통증 측정을 진행할 수 없습니다. 모든 내역을 초기화합니다.');
                sendStopSignal(runningType.value);
                resetAllMeasurements(); // 전체 초기화 함수 호출
            }
        }
    )
</script>